import { useL10n } from "@ews/react-localization-context";
import { IonInput, IonLabel, IonSegmentButton } from "@ionic/react";
import { useRef, useState } from "react";
import { SwiperSlide, useSwiper } from "swiper/react";
import { useIsMobile } from "../../../Responsive";
import SettingsSwiper from "../../../Settings/SettingsComponents/SettingsSwiper/SettingsSwiper";
import SettingsGrid from "../../../Settings/SettingsGrid/SettingsGrid";
import SettingsSegment from "../../../Settings/SettingsSegment/SettingsSegment";


import { DisplayTabProps, Page, SettingsOverlayProps } from "./types";
//import style from './SettingsOverlay.module.scss';
import { useMyProfileId } from "../../../Login/LoginProvider";
import Overflow from "../../../Overflow/Overflow";
import DetailsSettings from "../DetailsSettings/DetailsSettings";
import EmailSettings from "../EmailSettings/EmailSettings";
import LanguageFormatSettings from "../LanguageFormatSettings/LanguageFormatSettings";
import MainSettings from "../MainSettings/MainSettings";
import PermissionsSettings from "../PermissionsSettings /PermissionsSettings";
import PushSettings from "../PushSettings/PushSettings";
import SystemViewSettings from "../SystemViewSettings/SystemViewSettings";

const DisplayTab: React.FC<DisplayTabProps> = ({ name, display, children }) =>
{

    if (name === display) {
        return <>{children}</>;
    }

    return <></>;

};


const SettingsOverlay: React.FC<SettingsOverlayProps> = ({ user, onClose }) =>
{

    const me = useMyProfileId();

    const pageList: Page[] = [
        {
            value: 'general',
            title: "TD_ALLGEMEIN",
            child: <MainSettings id={user.id} />
        },
        {
            value: 'details',
            title: "TD_DETAILS2",
            child: <DetailsSettings id={user.id!} />
        },
        {
            value: 'system-view',
            title: "COM_FACPMANAGEMENT_USER_ACCOUNT_SYSTEM",
            child: <SystemViewSettings id={user.id!} />
        },
        {
            value: 'push',
            title: "COM_FACPMANAGEMENT_SHARE_PUSH",
            child: <PushSettings id={user.id!} />
        },
        {
            value: 'email',
            title: "COM_CONTACT_EMAIL_LABEL",
            child: <EmailSettings id={user.id!} />
        },
        {
            value: 'language/format',
            title: "COM_FACPMANAGEMENT_USER_ACCOUNT_FORMATTING",
            child: <LanguageFormatSettings id={user.id!} />
        },
    ];

    if (me !== user.id)
        pageList.splice(3, 0, {
            value: 'rights',
            title: "COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS",
            child: <PermissionsSettings id={user.id!} />
        });

    const mobileView = useIsMobile();
    const SliderComponent = mobileView ? SwiperSlide : ({ children }: { children: React.ReactNode; }) => <section>{children}</section>;

    const [currentSegment, setCurrentSegment] = useState<string>('general');
    const slideToRef = useRef<number>(0);
    const SwiperRef = useRef<any>();

    const { translate: t } = useL10n();

    const SwiperButtonNext: React.FC<{ swipeRef: any; }> = ({ swipeRef }) =>
    {
        const swiper = useSwiper();
        return <IonInput
            label=""
            ref={swipeRef}
            onClick={(e) =>
            {
                swiper.slideTo(slideToRef.current);
            }}
            hidden />;
    };

    return <>
        {/* <IonContent id="settingsContent" className={style.overlaySettings} fullscreen> */}

        <SettingsSegment value={currentSegment} onSelect={(current: string) => setCurrentSegment(current)}>
            {pageList.map((segment, index) => (

                <IonSegmentButton key={segment.value} value={segment.value} onClick={() =>
                {
                    if (mobileView) {
                        slideToRef.current = index;
                        SwiperRef.current.click();
                        setCurrentSegment(segment.value);
                    }
                }}>
                    <IonLabel>{t(segment.title)}</IonLabel>
                </IonSegmentButton>
            ))}
        </SettingsSegment>

        <Overflow minHeight={"calc(100% - 56px"} maxHeight={"calc(100% - 56px"}>
            <SettingsSwiper onSlideChange={(index) =>
            {
                slideToRef.current = index;
                setCurrentSegment(pageList[index].value);

            }}>
                {mobileView && <SwiperButtonNext swipeRef={SwiperRef} />}

                {pageList.map((page, index) =>
                {
                    const { child, value } = page;
                    return <SliderComponent key={index}>
                        <DisplayTab name={value} display={currentSegment}>
                            <SettingsGrid>
                                {child}
                            </SettingsGrid>
                        </DisplayTab>
                    </SliderComponent>;
                })}

            </SettingsSwiper>
        </Overflow>
        {/* </IonContent> */}

    </>;

};

export default SettingsOverlay;
